export default __webpack_public_path__ + "static/media/green_anim.e0203229.gif";